import { render, staticRenderFns } from "./RosterTwo.vue?vue&type=template&id=60daffc8"
import script from "./RosterTwo.vue?vue&type=script&lang=js"
export * from "./RosterTwo.vue?vue&type=script&lang=js"
import style0 from "./RosterTwo.vue?vue&type=style&index=0&id=60daffc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports